export default "__VITE_ASSET__C6QqZ2_I__"